<template>
<span class="value-show">{{value}}</span>
</template>
<script>

export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      let str = ""
      if(this.start_date){
        str += this.start_date
        if(this.end_date){
          str += ' - ' + this.end_date
        }
        return str
      }else{
        return ''
      }
    },
    start_date(){
      if(this.item.start_date){
        return moment(this.item.start_date, "YYYY MM DD").format("DD/MM/YY")
      }else{
        return false
      }
    },
    end_date(){
      if(this.item.end_date){
        return moment(this.item.end_date, "YYYY MM DD").format("DD/MM/YY")
      }else{
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValuePeriod.vue?916930b8